import SectionSeparator from './SectionSeparator';

export default SectionSeparator;
